module.exports = __webpack_public_path__ + "img/license_image13.269ae404.png";